"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9465],{

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// UNUSED EXPORTS: productIdToCluster

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var _obj1;
var productIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var ProductSignUp = function(_param) {
    var displayImage = _param.displayImage, useCtaText = _param.useCtaText, buttonSize = _param.buttonSize, withButtonArrow = _param.withButtonArrow, ctaText = _param.ctaText, _productType = _param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = _param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = _param.signupClusterId, useCtaIcon = _param.useCtaIcon, _buttonColor = _param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = _param.invert, beforeSubmitCallback = _param.beforeSubmitCallback, excludeFromWMHighIntentExperienceTest = _param.excludeFromWMHighIntentExperienceTest, extraData = _param.extraData, restOfConfig = _object_without_properties(_param, [
        "displayImage",
        "useCtaText",
        "buttonSize",
        "withButtonArrow",
        "ctaText",
        "productType",
        "selectedProductIds",
        "signupClusterId",
        "useCtaIcon",
        "buttonColor",
        "invert",
        "beforeSubmitCallback",
        "excludeFromWMHighIntentExperienceTest",
        "extraData"
    ]);
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = productIdToCluster[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({}, restOfConfig), {
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    updateClusters();
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: _object_spread({
                    selectedProduct: productType
                }, extraData || {}),
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            }))
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 9465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ background_image_cards_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/desktop-background-image-card/desktop-background-image-cards.scss.js



var getCardHeightStyle = function(defaultHeight) {
    var factor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return defaultHeight ? "calc(".concat(defaultHeight, " * ").concat(factor, ")") : "auto";
};
var StyledBackgroundImageCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezgnr0x0"
})("position:relative;overflow:hidden;height:", function(param) {
    var cardHeight = param.cardHeight;
    return cardHeight || "auto";
}, ";.paragraph-wrapper{position:relative;z-index:", z_index/* TOP_BAR */.sE, ";}&.active{.card-image{opacity:0;}.background-video{opacity:1;}}&:not(.active){.background-video{transition:opacity 0.5s ease-in-out;}}.card-image{position:absolute;z-index:", z_index/* LAYER_ONE */.KW, ";width:100%;height:100%;top:0;left:0;bottom:0;right:0;background-repeat:no-repeat;background-position:center;background-size:", function(param) {
    var cardHeight = param.cardHeight;
    return "auto ".concat(cardHeight);
}, ";background-image:", function(param) {
    var backgroundImage = param.backgroundImage;
    return "url(".concat(backgroundImage, ")");
}, ";}.background-video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return cardHeight || "auto";
}, ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;z-index:", z_index/* LAYER_TWO */.wc, ";opacity:0;video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return cardHeight || "auto";
}, ";object-fit:contain;}}@media (max-width:", vp_sizes.LG, "px) and (min-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.82);
}, ";.background-video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.82);
}, ";video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.82);
}, ";}}.card-image{background-size:", function(param) {
    var cardHeight = param.cardHeight;
    return "auto ".concat(getCardHeightStyle(cardHeight, 0.82));
}, ";}.title-wrapper{margin-bottom:8px;}}@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px) and (min-width:", vp_sizes.MD, "px){height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.78);
}, ";.background-video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.78);
}, ";video{height:", function(param) {
    var cardHeight = param.cardHeight;
    return getCardHeightStyle(cardHeight, 0.78);
}, ";}}.card-image{background-size:", function(param) {
    var cardHeight = param.cardHeight;
    return "auto ".concat(getCardHeightStyle(cardHeight, 0.78));
}, ";}.title-wrapper{margin-bottom:4px;.card-title{font-size:2rem;}}.paragraph-wrapper .paragraph-body{font-size:1rem;line-height:24px;}}");

// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/button-types.js
var button_types = __webpack_require__(96800);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/product-signup-and-learn-more-buttons/product-signup-button.scss.js

var StyledProductSignupButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eabi1r40"
})("display:flex;flex-direction:row;justify-content:center;gap:20px;&.product-signup-wrapper{.product-sign-up{justify-content:center;height:fit-content;.signup-button{height:35px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/product-signup-and-learn-more-buttons/product-signup-and-learn-more-buttons.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var _obj;
var PRODUCT_TO_MINI_SITE_URL = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, links/* CRM_MINI_SITE_LINK */.mgz), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, links/* SOFTWARE_MINI_SITE_LINK */.DDD), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler), (0,_define_property/* default */.Z)(_obj, products/* SERVICE_PRODUCT_ID */.Ai, links/* SERVICE_MINI_SITE_LINK */.Kon), _obj);
var ProductSignupAndLearnMoreButtons = function(_param) {
    var translate = _param.translate, withArrow = _param.withArrow, button = _object_without_properties(_param, [
        "translate",
        "withArrow"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignupButton, {
        className: "product-signup-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, _object_spread_props(_object_spread({
                withButtonArrow: withArrow
            }, button), {
                buttonSize: sizes.XS
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                isWithArrow: withArrow,
                url: PRODUCT_TO_MINI_SITE_URL[button === null || button === void 0 ? void 0 : button.productType],
                color: button === null || button === void 0 ? void 0 : button.buttonColor,
                buttonText: translate("signup.learnMore"),
                isOpenLinkInNewTab: true
            })
        ]
    });
};
/* harmony default export */ var product_signup_and_learn_more_buttons = (ProductSignupAndLearnMoreButtons);

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.scss.js


var StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqx6xni0"
})("border:", function(param) {
    var borderColor = param.borderColor;
    return "1px solid ".concat(colors/* default */.Z[borderColor]);
}, ";color:", function(param) {
    var borderColor = param.borderColor;
    return colors/* default */.Z[borderColor];
}, ";padding:4px 8px;margin:auto;border-radius:4px;width:fit-content;font-size:0.875rem;");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.js


var Label = function(param) {
    var text = param.text, borderColor = param.borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
        className: "generic-text",
        borderColor: borderColor,
        children: text
    });
};
/* harmony default export */ var label = (Label);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/card-button.scss.js


var StyledCardButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efxh6fb0"
})("margin-top:24px;@media (max-width:", vp_sizes.LG, "px){margin-top:16px;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/card-button.js

function card_button_define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_button_define_property1(target, key, source[key]);
        });
    }
    return target;
}
function card_button_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = card_button_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function card_button_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var card_button_obj;
var BUTTON_TYPE_TO_COMPONENT = (card_button_obj = {}, (0,_define_property/* default */.Z)(card_button_obj, button_types/* ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE */.q.PRODUCT_SIGNUP_AND_LEARN_MORE, product_signup_and_learn_more_buttons), (0,_define_property/* default */.Z)(card_button_obj, button_types/* ButtonTypes.LABEL */.q.LABEL, label), card_button_obj);
var CardButton = function(_param) {
    var buttonType = _param.buttonType, buttonConfig = card_button_object_without_properties(_param, [
        "buttonType"
    ]);
    var ButtonComponent = BUTTON_TYPE_TO_COMPONENT[buttonType];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardButton, {
        className: "card-button-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, card_button_object_spread({}, buttonConfig))
    });
};
/* harmony default export */ var card_button = ((0,generic_config_context/* withGenericConfig */.P)(CardButton));

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/desktop-background-image-card/desktop-background-image-card.js
function desktop_background_image_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_background_image_card_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_background_image_card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function desktop_background_image_card_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function desktop_background_image_card_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        desktop_background_image_card_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var DEFAULT_PARAGRAPH = {
    topic: {}
};
var COLOUDINERY_FIRST_FRAME_FORMAT = "so_0";
var IMAGE_EXTENSION = "jpg";
var DesktopBackgroundImageCard = function(param) {
    var backgroundVideo = param.backgroundVideo, cardHeight = param.cardHeight, paragraph = param.paragraph, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, button = param.button, onHover = param.onHover, backgroundImage = param.backgroundImage, marginRight = param.marginRight, marginLeft = param.marginLeft, marginTop = param.marginTop, marginBottom = param.marginBottom, borderRadius = param.borderRadius;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var videoUrl = (0,react.useMemo)(function() {
        return backgroundVideo && encodeURI((0,cloudinary_service.generateCloudinaryVideoUrl)(backgroundVideo === null || backgroundVideo === void 0 ? void 0 : backgroundVideo.formats[0]));
    }, [
        backgroundVideo
    ]);
    var firstFrameImage = (0,react.useMemo)(function() {
        if (!videoUrl) return null;
        var firstFrameFormat = videoUrl.replace(/\/upload\//, "/upload/".concat(COLOUDINERY_FIRST_FRAME_FORMAT, "/"));
        return firstFrameFormat.replace(/(\.[\w\d_-]+)$/i, ".".concat(IMAGE_EXTENSION));
    }, [
        videoUrl
    ]);
    var cardBackgroundImage = (0,react.useMemo)(function() {
        return firstFrameImage || encodeURI((0,cloudinary_service.generateCloudinaryImageUrl)(backgroundImage));
    }, [
        backgroundImage,
        firstFrameImage
    ]);
    var onMouseEnter = function() {
        var _videoRef_current;
        videoRef === null || videoRef === void 0 ? void 0 : (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.play();
        setIsHovered(true);
        onHover === null || onHover === void 0 ? void 0 : onHover();
    };
    var onMouseLeave = function() {
        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        setIsHovered(false);
    };
    var getStyle = function() {
        var style = {};
        if (marginRight) style.marginRight = marginRight;
        if (marginLeft) style.marginLeft = marginLeft;
        if (marginTop) style.marginTop = marginTop;
        if (marginBottom) style.marginBottom = marginBottom;
        if (borderRadius) style.borderRadius = borderRadius;
        return Object.keys(style).length > 0 ? style : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBackgroundImageCard, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: classnames_default()("background-image-card", {
            active: videoUrl && isHovered
        }),
        cardHeight: cardHeight,
        backgroundImage: cardBackgroundImage,
        style: getStyle(),
        children: [
            videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    ref: videoRef,
                    loop: true,
                    muted: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: videoUrl
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph-wrapper",
                style: {
                    marginTop: fullParagraphAdvancedConfig === null || fullParagraphAdvancedConfig === void 0 ? void 0 : fullParagraphAdvancedConfig.marginTop
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, desktop_background_image_card_object_spread_props(desktop_background_image_card_object_spread({}, fullParagraphAdvancedConfig, DEFAULT_PARAGRAPH, paragraph), {
                        titleClassName: "card-title"
                    })),
                    (button === null || button === void 0 ? void 0 : button.buttonType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_button, desktop_background_image_card_object_spread({}, button))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-image"
            })
        ]
    });
};
/* harmony default export */ var desktop_background_image_card = (DesktopBackgroundImageCard);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/mobile-background-image-card/mobile-background-image-cards.scss.js


var StyledMobileBackgroundImageCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eamb1sp0"
})("position:relative;width:100vw;padding:0 ", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || 0;
}, ";border-radius:12px;.details-wrapper{top:0;width:calc(100vw - ", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || 0;
}, " * 2);position:absolute;z-index:", z_index/* TOP_BAR */.sE, ";display:flex;flex-direction:column;align-items:center;.card-button-component{width:fit-content;.product-signup-wrapper{flex-direction:column;align-content:center;width:fit-content;display:flex;align-items:center;.product-sign-up{.signup-button{height:fit-content;}}}}}.mobile-card-image{img{width:100%;object-fit:cover;position:relative;border-radius:12px;}}");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/mobile-background-image-card/mobile-background-image-card.js
function mobile_background_image_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_background_image_card_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_background_image_card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_background_image_card_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_background_image_card_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_background_image_card_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var mobile_background_image_card_DEFAULT_PARAGRAPH = {
    topic: {}
};
var MobileBackgroundImageCard = function(param) {
    var mobileBackgroundImage = param.mobileBackgroundImage, backgroundImage = param.backgroundImage, paragraph = param.paragraph, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, button = param.button, horizontalPadding = param.horizontalPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileBackgroundImageCard, {
        horizontalPadding: horizontalPadding,
        className: classnames_default()("mobile-background-image-card"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                image: {
                    src: mobileBackgroundImage || backgroundImage
                },
                className: "mobile-card-image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "details-wrapper",
                style: {
                    marginTop: fullParagraphAdvancedConfig === null || fullParagraphAdvancedConfig === void 0 ? void 0 : fullParagraphAdvancedConfig.marginTop
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, mobile_background_image_card_object_spread_props(mobile_background_image_card_object_spread({}, fullParagraphAdvancedConfig, mobile_background_image_card_DEFAULT_PARAGRAPH, paragraph), {
                        titleClassName: "card-title"
                    })),
                    (button === null || button === void 0 ? void 0 : button.buttonType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_button, mobile_background_image_card_object_spread({}, button))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-image"
            })
        ]
    });
};
/* harmony default export */ var mobile_background_image_card = (MobileBackgroundImageCard);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-component.scss.js


var StyledBackgroundImageCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e24l3ew0"
})("max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;margin:auto;min-width:", vp_sizes.SM, "px;display:grid;grid-template-columns:1fr 1fr;grid-gap:", function(param) {
    var cardsGap = param.cardsGap;
    return cardsGap || "12px";
}, ";@media (max-width:", vp_sizes.MD, "px){display:flex;flex-direction:column;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){min-width:unset;}");

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-component.js
function background_image_cards_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_image_cards_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_image_cards_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_image_cards_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_image_cards_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_image_cards_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function background_image_cards_grid_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = background_image_cards_grid_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function background_image_cards_grid_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var DEBOUNCE_HOVER_TIME = 1000;
var BackgroundImageCardsGridComponent = function(_param) {
    var cards = _param.cards, cardHeight = _param.cardHeight, fullParagraphAdvancedConfig = _param.fullParagraphAdvancedConfig, cardsGap = _param.cardsGap, props = background_image_cards_grid_component_object_without_properties(_param, [
        "cards",
        "cardHeight",
        "fullParagraphAdvancedConfig",
        "cardsGap"
    ]);
    var onHover = lodash_debounce_default()(function(index) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.BACKGROUND_IMAGE_CARD_HOVERED, {
            info1: index
        });
    }, DEBOUNCE_HOVER_TIME);
    var CardComponent = (0,react.useMemo)(function() {
        return (0,responsive_hoc_component/* default */.Z)(desktop_background_image_card, mobile_background_image_card);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBackgroundImageCardsGridComponent, {
        cardsGap: cardsGap,
        className: "background-image-cards-grid-component",
        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
            return /*#__PURE__*/ (0,react.createElement)(CardComponent, background_image_cards_grid_component_object_spread(background_image_cards_grid_component_object_spread_props(background_image_cards_grid_component_object_spread({}, props), {
                key: index,
                onHover: function() {
                    return onHover(index);
                },
                fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
                cardHeight: cardHeight
            }), card));
        })
    });
};
/* harmony default export */ var background_image_cards_grid_component = (BackgroundImageCardsGridComponent);


/***/ })

}]);